import PropTypes from 'prop-types';

CheckboxGroup.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.array,
  options: PropTypes.array,
};

export function CheckboxGroup({ onChange, value = [], options = [] }) {
  const onSelected = function (checkboxValue) {
    let listCopy = [...value];
    if (listCopy.indexOf(checkboxValue) > -1) {
      listCopy.splice(listCopy.indexOf(checkboxValue), 1);
    } else {
      listCopy.push(checkboxValue);
    }
    onChange(listCopy);
  };

  return (
    <div className="option_area">
      {options.map((option) => {
        let id = option.value + option.label;
        return (
          <div className="option" key={option.value}>
            <div className="check_cover">
              <input
                type="checkbox"
                className="lw_checkbox"
                id={id}
                value={option.value}
                checked={value.includes(option.value)}
                onChange={() => onSelected(option.value)}
              />
              <label htmlFor={id}>{option.label}</label>
            </div>
          </div>
        );
      })}
    </div>
  );
}
